module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OffCanvas"
  }, [_c('p', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "am-icon-reorder am-fl",
    on: {
      "click": function($event) {
        _vm.OffCanvasOpen()
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "index am-fr",
    attrs: {
      "to": {
        name: 'index'
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "footer"
  }, [_c('router-link', {
    staticClass: "lxwm",
    attrs: {
      "to": {
        name: 'lxts',
        params: {
          nr: 'lxwm'
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "am-offcanvas",
    attrs: {
      "id": "dh-OffCanvas"
    }
  }, [_c('div', {
    staticClass: "am-offcanvas-bar"
  }, [_c('div', {
    staticClass: "am-offcanvas-content am-panel-group",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "meun",
    class: {
      active: _vm.$route.name === 'index'
    }
  }, [_c('i', {
    staticClass: "index icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "meun"
  }, [_c('i', {
    staticClass: "tzzjy icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.ListClose('#tzzjylist')
      }
    }
  }, [_vm._v("投资者教育")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "am-panel-collapse am-collapse zklist",
    attrs: {
      "id": "tzzjylist"
    }
  }, _vm._l((_vm.tzzjytitle), function(item, key, index) {
    return _c('div', {
      key: key,
      staticClass: "zk_meun",
      class: {
        active: _vm.$route.path === '/tzzjy/' + key
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "meun"
  }, [_c('i', {
    staticClass: "xxgs icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.ListClose('#xxgslist')
      }
    }
  }, [_vm._v("信息公示")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "am-panel-collapse am-collapse zklist",
    attrs: {
      "id": "xxgslist"
    }
  }, _vm._l((_vm.xxgstitle), function(item, key, index) {
    return _c('div', {
      key: key,
      staticClass: "zk_meun",
      class: {
        active: _vm.$route.path === '/xxgs/' + key
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'xxgs',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "meun",
    class: {
      active: _vm.$route.path === '/lxts/lxwm'
    }
  }, [_c('i', {
    staticClass: "lxwm icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lxts',
        params: {
          nr: 'lxwm'
        }
      }
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "meun",
    class: {
      active: _vm.$route.name === 'yjfk'
    }
  }, [_c('i', {
    staticClass: "yjfk icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'yjfk'
      }
    }
  }, [_vm._v("意见反馈")])], 1), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "meun",
    class: {
      active: _vm.$route.path === '/lxts/tsjy'
    }
  }, [_c('i', {
    staticClass: "tsjy icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lxts',
        params: {
          nr: 'tsjy'
        }
      }
    }
  }, [_vm._v("投诉建议")])], 1), _vm._v(" "), _c('hr')])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-276f1b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OffCanvas/OffCanvas.vue
// module id = 873
// module chunks = 2